import { callApi } from './api';

import { UpdatePickupDropoffReservationsRequest } from '@/types/pickupDropoff';

export const updatePickupDropoffReservations = async (
  input: UpdatePickupDropoffReservationsRequest
) => {
  const { status, result } = await callApi<boolean>(
    `pickup-dropoff-reservations`,
    'PUT',
    undefined,
    input,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
